import Modal from "react-bootstrap/Modal";
import {useState, useEffect, useRef} from "react";
import {SwalAlertClass} from "core/swalClass";

import axiApi from "ApiCaller";
import Form from "react-bootstrap/Form";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import MiniQ2Commands from "./models/MiniQ2Commands";
import TableParameters from "./TableParameters";
import {publishEvent} from "core/eventsConnector";
import ConditionalRender from "components/ConditionalRender";

const ItemModel = function () {
    return {
        value: "",
        name: "",
        topic: "",
        length: 0,
        parameters: "",
        command: "",
    };
};

const WordCommandModel = {
    currentBytes: 0,
    totalBytes: 0,
    sameBytes: false,
    length: 0,
    isValid: true,
    calculateLengths: function () {
        if (!this.value) {
            this.currentBytes = 0;
            this.length = 0;
        } else {
            this.length = this.value.length;
            this.currentBytes = this.value.includes(",") ? this.value.split(/,/).length : Math.ceil(this.length / 2);
        }
    },
};

const ModalSendCommand = ({show, setShow, items, mode}) => {
    const Alert = new SwalAlertClass({confirmButtonText: "Accept"});
    const [model, setModel] = useState(mode.current);
    const [item, setItem] = useState(new ItemModel());
    const [word, setWord] = useState({...WordCommandModel, value: ""});
    const commands = useRef([]);

    useEffect(() => {
        setModel(mode.current);
        commands.current = getOptions(mode.current);
    }, [mode]);

    const getOptions = (mode) => {
        switch (mode) {
            case "MQ2-4G":
                return MiniQ2Commands;
            default:
                return [];
        }
    };

    const findCommandByCode = (commandCode) => {
        if (!commandCode) {
            return null;
        }
        return (
            commands.current.find((option) => {
                return option.value === commandCode.substring(0, 2);
            }) || null
        );
    };

    const handleChangeSelect = (e) => {
        let selected = e.target;
        const selectedValue = selected.value;
        setWord({...word, ...WordCommandModel});
        if (!selectedValue) {
            setItem(new ItemModel());
            return;
        }
        setterCommand(selectedValue);
    };

    const handleWordInput = (e) => {
        const rawInput = e.target.value.trim();
        const word_ = {...WordCommandModel};
        word_.value = rawInput.replace(/\s+/g, "");
        if (!rawInput) {
            setItem(new ItemModel());
            setWord({...word_});
            return false;
        }
        word_.calculateLengths();
        setWord({...word_});
        setterCommand(rawInput);
    };

    const setterCommand = (commandCode) => {
        const item_ = findCommandByCode(commandCode);
        if (!item_) {
            setItem(new ItemModel());
            return;
        }
        //item_.command = commandCode;
        setItem(item_);
    };

    const handleClose = () => {
        setShow(false);
        setItem(new ItemModel());
        setWord({...WordCommandModel, value: ""});
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!item.topic) {
            Alert.error("Error", "Debe seleccionar un topic para enviar el comando.");
            return;
        }
        const payload = {
            uuids: items.current.getChosenUuids(),
            command: item.value,
            value: word.value,
            topic: item.topic,
            model: model,
        };
        const resp = await axiApi.post("/api/devices/downs/send/command/", payload);
        if (resp.data) {
            Alert.success("Solicitud", "Se han encolado las configuraciones para su envío.").then((resp) => {
                publishEvent("reload:view:sender", {});
                setItem(new ItemModel());
                setShow(false);
            });
        }
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} animation={true} aria-modal={true} centered size="lg">
                <Modal.Header closeButton className="preview-canvas mb-0">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="fa-terminal" />
                    </div>
                    <div className="preview-title d-inline-flex align-items-center">
                        <Modal.Title>Enviar commando</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={(e) => e.preventDefault()}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-8">
                                    <p>Seleccione el comando que desea enviar a los dispositivos seleccionados.</p>
                                    <h5>Dispositivos seleccionados: {items.current.chosen.length}</h5>
                                    <div className="form-group mt-4">
                                        <label htmlFor="command">Comando</label>
                                        <select
                                            className="form-control"
                                            id="command"
                                            onChange={handleChangeSelect}
                                            value={item.value}>
                                            <option value="">Seleccionar un commando</option>
                                            {getOptions(model).map((item_, idx) => (
                                                <option value={item_.value} data-topic={item_.topic} key={idx}>
                                                    {`${item_.name}`}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-12 mt-4">
                                    <div className="form-group">
                                        <label htmlFor="value">Comando a enviar</label>
                                        <textarea
                                            className={`form-control ${!word.isValid ? "is-invalid border-danger" : ""}`}
                                            id="value"
                                            value={word.value}
                                            rows="2"
                                            onChange={handleWordInput}
                                        />
                                        <ConditionalRender condition={!word.isValid}>
                                            <small className="form-text text-danger">
                                                El comando introducido no es ninguno de los soportados.
                                            </small>
                                        </ConditionalRender>
                                        <small className="form-text text-muted">
                                            {!word.isHexa
                                                ? ` Caracteres: ${word.length}`
                                                : ` Caracteres: ${word.length} (${word.currentBytes} bytes)`}
                                        </small>
                                    </div>
                                </div>
                                <ConditionalRender condition={item && item.parameters}>
                                    <div className="col-12 mt-4">
                                        <h6>Parametros</h6>
                                        <div className="row">
                                            <div className="col-6">
                                                <strong>Topic:</strong> {item.topic}
                                            </div>
                                            <div className="col-6 text-end">
                                                <span className="ms-auto">
                                                    <small className={word.isValid ? "text-success" : "text-danger"}>
                                                        {`Medida: ${word.currentBytes}/${word.totalBytes} bytes`}
                                                    </small>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            <TableParameters item={item} word={word} setWord={setWord} />
                                        </div>
                                    </div>
                                </ConditionalRender>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={handleClose}>
                        Cancelar
                    </button>
                    <button type="button" className="btn btn-primary" onClick={onSubmit}>
                        Enviar
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalSendCommand;
